<template>
  <!-- "FAST - Submitted" on the BF2026 canvas: a one-time FAST gift to the Building
       Fund that went through. Only for SUCCESS; pending and failed keep the generic
       status screens. No Dreams & Prayers here, as in the frame — those are on the
       BF2026 thumbnail's page (D4, D5). -->
  <div
    class="hogc-theme-campaign bg-campaign-surface w-full min-h-full flex flex-col"
    data-test="bf-fast-submitted"
  >
    <PledgeHeader :back="back" banner small>You are a part<br />of history!</PledgeHeader>
    <div class="px-[16px] md:px-[24px] lg:px-[28px] pt-[24px] pb-[24px]">
      <div class="w-full md:max-w-2xl md:mx-auto">
        <DsCard class="flex flex-col gap-[10px]">
          <PledgeCardTitle tone="gift">
            <template #icon>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.4 4.5 7 4.5c2 0 3.5 1.1 5 3 1.5-1.9 3-3 5-3 3.6 0 5.6 3.5 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"
                />
              </svg>
            </template>
            Thank you for giving!
          </PledgeCardTitle>
          <div class="h-px bg-campaign-divider" />
          <dl class="m-0 flex flex-col gap-[8px] text-[14px] text-campaign-ink">
            <div v-for="row in rows" :key="row.label" class="flex justify-between gap-[12px]">
              <dt class="text-campaign-muted">{{ row.label }}</dt>
              <dd class="m-0 font-semibold text-right shrink-0" :data-test="row.test">
                {{ row.value }}
              </dd>
            </div>
          </dl>
        </DsCard>
      </div>
    </div>
    <!-- Back to MyGiving is pinned to the bottom of the screen, as confirm pins its
         slider: sticky in ion-content, which scrolls once the full-bleed banner makes
         the page taller than the screen (an iPhone 16 Pro by ~64pt). When everything
         fits, the band grows to the bottom of this full-height column and keeps the
         button at its foot. -->
    <section
      class="sticky bottom-0 z-10 flex-grow flex flex-col justify-end bg-campaign-surface-alt px-[16px] pt-[16px] pb-[max(32px,calc(env(safe-area-inset-bottom)+16px))] md:pb-[56px]"
      data-test="bf-fast-footer"
    >
      <div class="w-full md:max-w-2xl md:mx-auto">
        <DsButton
          variant="campaign"
          size="52"
          class="w-full"
          data-test="bf-fast-back"
          @click="$emit('done')"
        >
          Back to MyGiving
        </DsButton>
      </div>
    </section>
  </div>
</template>

<script>
import { Button as DsButton, Card as DsCard } from '@team-hogc/hogc-one-design-system';
import PledgeCardTitle from './PledgeCardTitle.vue';
import PledgeHeader from './PledgeHeader.vue';
import { BF_FAST_GIVING_TO } from '@/constants/MyGiving/building-fund-pledge';
import { formatGiftAmount } from '@/utils/building-fund-pledge';
import { campaignStatusBar, claimStatusBar, releaseStatusBar } from '@/utils/status-bar-claims';

export default {
  name: 'BfFastSubmitted',

  components: { DsButton, DsCard, PledgeCardTitle, PledgeHeader },

  props: {
    amount: {
      type: [Number, String],
      default: null,
    },
    month: {
      type: String,
      default: '',
    },
    // The back handler, when there is somewhere to go back to (opened from Updates).
    back: {
      type: Function,
      default: null,
    },
  },

  emits: ['done'],

  computed: {
    rows() {
      return [
        { label: 'Amount', value: formatGiftAmount(this.amount), test: 'bf-fast-amount' },
        { label: 'Month', value: this.month, test: 'bf-fast-month' },
        { label: 'Giving to', value: BF_FAST_GIVING_TO, test: 'bf-fast-giving-to' },
      ];
    },
  },

  // The navy band runs under the status bar, as on the pledge routes. This screen
  // is a state of the transaction status route, not a route, so it claims for itself.
  mounted() {
    claimStatusBar('bf-fast-submitted', campaignStatusBar());
  },

  beforeUnmount() {
    releaseStatusBar('bf-fast-submitted');
  },
};
</script>
